import findIndex from "lodash/findIndex"
import find from "lodash/find"
import remove from "lodash/remove"
import concat from "lodash/concat"
import {
  CONFIRM_ROLLOFF_TICKET_CANCEL_FAILED,
  CONFIRM_ROLLOFF_TICKET_CANCEL_FULFILLED,
  CONFIRM_ROLLOFF_TICKET_CANCEL_PENDING,
  GET_ROLLOFF_TICKET_DETAILS_FAILED,
  GET_ROLLOFF_TICKET_DETAILS_FULFILLED,
  GET_ROLLOFF_TICKET_DETAILS_PENDING,
  GET_ROLLOFF_TICKETS_FAILED,
  GET_ROLLOFF_TICKETS_FULFILLED,
  GET_ROLLOFF_TICKETS_PENDING,
  INIT_ROLLOFF_TICKET_CANCEL,
  RESET_ROLLOFF_TICKET_CANCEL,
  RESET_ROLLOFF_TICKET_DETAILS,
  SET_ROLLOFF_DISPLAY_METHOD,
  SET_ROLLOFF_TICKET_DETAILS_INFO,
  SET_RO_TICKET_CANCEL_FLAG,
  SET_RO_STATUS_DROPDOWN_STATUS,
  SET_RO_STATUS_DROPDOWN_VIEW_BY,
  RESET_MYSERVICES_DASHBOARD,
  RESET_DASHBOARD_FROM_GETTING_STARTED,
  CLEAR_CANCEL_ORDER_STATUS,
} from "constants-lib/actionTypes"
import { NO } from "constants-lib/common"

const initialState = {
  cancelTickets: [],
  cancelRollOffTicketState: ``,
  cancelledRollOffTicket: ``,
  displayMethod: `list`,
  getRollOffTicketDetailsState: ``,
  getRollOffTicketsState: ``,
  rollOffTicketDetails: {},
  rollOffTicketDetailsAction: ``,
  rollOffTickets: {},
  selectedRollOffRequestId: ``,
  selectedStatus: ``,
  selectedViewBy: ``,
}

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case CONFIRM_ROLLOFF_TICKET_CANCEL_FAILED:
      return {
        ...state,
        cancelledRollOffTicket: ``,
        cancelRollOffTicketState: `failed`,
      }

    case CONFIRM_ROLLOFF_TICKET_CANCEL_FULFILLED:
      return {
        ...state,
        cancelledRollOffTicket: action.payload.rollOffRequestId,
        cancelRollOffTicketState: `fulfilled`,
      }

    case CONFIRM_ROLLOFF_TICKET_CANCEL_PENDING:
      return {
        ...state,
        cancelRollOffTicketState: `pending`,
      }

    case GET_ROLLOFF_TICKET_DETAILS_FAILED:
      return {
        ...state,
        rollOffTicketDetails: [],
        rollOffTicketDetailsAction: ``,
        getRollOffTicketDetailsState: `failed`,
      }

    case GET_ROLLOFF_TICKET_DETAILS_FULFILLED:
      return {
        ...state,
        rollOffTicketDetails: action.payload.ticketDetails,
        getRollOffTicketDetailsState: `fulfilled`,
      }

    case GET_ROLLOFF_TICKET_DETAILS_PENDING:
      return {
        ...state,
        getRollOffTicketDetailsState: `pending`,
      }

    case GET_ROLLOFF_TICKETS_FAILED:
      return {
        ...state,
        cancelTickets: [],
        rollOffTickets: {},
        getRollOffTicketsState: `failed`,
      }

    case GET_ROLLOFF_TICKETS_FULFILLED:
      return {
        ...state,
        cancelTickets: [],
        rollOffTickets: action.payload.tickets,
        getRollOffTicketsState: `fulfilled`,
      }

    case GET_ROLLOFF_TICKETS_PENDING:
      return {
        ...state,
        getRollOffTicketsState: `pending`,
      }

    case INIT_ROLLOFF_TICKET_CANCEL:
      return {
        ...state,
        cancelTickets: concat(state.cancelTickets, action.payload),
      }

    case RESET_ROLLOFF_TICKET_CANCEL:
      const newCancelTicketArray = state.cancelTickets
      remove(newCancelTicketArray, (o) => o.rollOffRequestId === action.payload)

      return {
        ...state,
        cancelTickets: newCancelTicketArray,
      }

    case RESET_ROLLOFF_TICKET_DETAILS:
      return {
        ...state,
        rollOffTicketDetails: {},
        rollOffTicketDetailsAction: ``,
        getRollOffTicketDetailsState: ``,
      }

    case SET_ROLLOFF_DISPLAY_METHOD:
      return {
        ...state,
        displayMethod: action.payload,
      }

    case SET_ROLLOFF_TICKET_DETAILS_INFO:
      return {
        ...state,
        rollOffTicketDetailsAction: action.payload.actionType,
        selectedRollOffRequestId: action.payload.rollOffRequestId,
        starRDY: action.payload.starRDY || NO,
      }

    case SET_RO_TICKET_CANCEL_FLAG:
      const matchedTicket = find(state.cancelTickets, [
        `rollOffRequestId`,
        action.payload,
      ])

      const cancelledTicket = {
        rollOffRequestId: matchedTicket.rollOffRequestId,
        isCancelled: true,
      }

      const index = findIndex(state.cancelTickets, [
        `rollOffRequestId`,
        action.payload,
      ])

      const updatedTicketArray = state.cancelTickets.map((s) => s)
      updatedTicketArray.splice(index, 1, cancelledTicket)

      return {
        ...state,
        cancelTickets: updatedTicketArray,
      }

    case SET_RO_STATUS_DROPDOWN_STATUS:
      return {
        ...state,
        selectedStatus: action.payload,
      }

    case SET_RO_STATUS_DROPDOWN_VIEW_BY:
      return {
        ...state,
        selectedViewBy: action.payload,
      }

    case RESET_MYSERVICES_DASHBOARD:
      return initialState

    case RESET_DASHBOARD_FROM_GETTING_STARTED:
      return initialState

    case CLEAR_CANCEL_ORDER_STATUS:
      return {
        ...state,
        cancelRollOffTicketState: ``,
      }

    default:
      return state
  }
}
